import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { spacingValue } from '../utils';

function misc(_ref) {
  var lineHeight = _ref.lineHeight,
      uppercase = _ref.uppercase,
      styles = _objectWithoutPropertiesLoose(_ref, ["lineHeight", "uppercase"]);

  if (styles.boxShadow && styles.boxShadow.constructor === Array) {
    styles.boxShadow = styles.boxShadow.join(', ');
  }

  if (typeof lineHeight !== 'undefined') {
    styles.lineHeight = typeof lineHeight === 'number' ? spacingValue(lineHeight) : lineHeight;
  }

  if (uppercase) {
    styles.textTransform = 'uppercase';
    styles.letterSpacing = '0.15em';
  }

  return styles;
}

export default misc;